import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { search_channel_all } from "@/api/dataAll/dataAll";
import { serchSelect, tabulation } from "@/mixins/index";
import { sharingList, delSharing } from "@/api/financial/consumptionDetails";
import addShareProportion from "./components/addShareProportion";
export default {
  name: "shareProportion",
  components: {
    addShareProportion: addShareProportion
  },
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      tableData: [],
      value2: [],
      total: 0,
      page: 1,
      sels: [],
      selsString: '',
      searchchannelsAll: [],
      issubstitution: false
    };
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.getAllchannel();
    }, 500);
  },
  activated: function activated() {
    if (this.tableData.length) {
      this.searchClick();
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.searchData.platform = '';
      this.searchData.game = '';
      this.searchData.pkg = ''; // if(!this.searchData.channel){
      //   this.$message.error('请选择渠道')
      //   return
      // }

      this.reqLoading = true;
      sharingList(this.searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['channel'];
          _this2.tableData = res.data.length ? _this2.$utils.dataConversion(res.data, list) : [];

          _this2.$nextTick(function () {
            _this2.getTableRight();
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    handleSource: function handleSource(id) {
      this.$refs.addShareProportion.init(id);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this3.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDelete: function handleDelete(ids) {
      var _this4 = this;

      var id = ids.toString();
      this.$confirm(this.$t('confirmDeleteSharing'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delSharing({
                  ids: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.searchClick();

                    _this4.$message({
                      type: "success",
                      message: _this4.$t('deleteSuccessExclamation')
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};